import { ref, isRef, Ref } from 'vue'
import { useQuery } from '@cqrs/vue-composables-cqrs'
import * as q from './queries-core'
export function useGridProjectByIdQueryV1(workspaceId?: number | Ref<number>, portfolioId?: string | Ref<string>, projectId?: string | Ref<string>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>(portfolioId)
	const _projectId = isRef<string>(projectId) ? projectId : ref<string>(projectId)
	const result = {
		workspaceId: _workspaceId,
		portfolioId: _portfolioId,
		projectId: _projectId,
		...useQuery(() => new q.GridProjectByIdQueryV1(_workspaceId.value, _portfolioId.value, _projectId.value))
	}
	return {
		...result,
		runGridProjectByIdQueryV1: result.run,
		modelGridProjectByIdQueryV1: result.model,
	}
}

export function useMyPortfolioProjectsPageQueryV1(workspaceId?: number | Ref<number>, tchProjectId?: number | Ref<number>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _tchProjectId = isRef<number>(tchProjectId) ? tchProjectId : ref<number>(tchProjectId)
	const result = {
		workspaceId: _workspaceId,
		tchProjectId: _tchProjectId,
		...useQuery(() => new q.MyPortfolioProjectsPageQueryV1(_workspaceId.value, _tchProjectId.value))
	}
	return {
		...result,
		runMyPortfolioProjectsPageQueryV1: result.run,
		modelMyPortfolioProjectsPageQueryV1: result.model,
	}
}

